<template>
   <QCard id="subscription-error-card">
      <QCardSection class="bg-red text-white">
         <div class="text-h6">Subscription Error</div>
      </QCardSection>
      <QCardSection class="q-pa-md">
         <p class="text-body1">
            There was an error validating your subscription. Please contact
            <a href="mailto:support@ezbot.ai">support@ezbot.ai</a>
         </p>
         <div class="q-mt-lg">
            <QExpansionItem
               icon="mdi-xml"
               label="Debug Information"
               caption="Technical details about your subscription"
               header-class="text-grey-8"
               expand-icon-class="text-primary"
               switch-toggle-side
            >
               <QCard class="debug-card q-ma-sm">
                  <QCardSection class="q-pa-sm bg-grey-2">
                     <div class="w-full">
                        <div class="w-full">
                           <QItem class="debug-item">
                              <QItemSection>
                                 <QItemLabel class="text-weight-medium w-full">
                                    <VCodeBlock
                                       :code="JSON.stringify(decodedToken)"
                                       highlightjs
                                       lang="json"
                                       theme="github"
                                       copy-button
                                       :persistent-copy-button="true"
                                       style="width: 100%"
                                    />
                                 </QItemLabel>
                              </QItemSection>
                           </QItem>
                        </div>
                     </div>
                  </QCardSection>
               </QCard>
            </QExpansionItem>
         </div>
      </QCardSection>
   </QCard>
</template>

<script lang="ts" setup>
import { getAuthData } from "@/services/clerk"
import { VCodeBlock } from "@wdns/vue-code-block"

const { decodedToken } = await getAuthData()
</script>

<style scoped>
.bg-red {
   background-color: #f44336;
}

.debug-list {
   list-style-type: none;
   margin: 0;
   text-align: center;
}
#subscription-error-card {
   width: 100%;
   max-width: 600px;
   margin: 0 auto;
}

.debug-item-container {
   width: 100%;
   padding: 0 8px;
   margin-bottom: 8px;
}

@media (min-width: 600px) {
   .debug-item-container {
      width: 33.33%;
      float: left;
   }
}
</style>
